export default __webpack_public_path__ + "static/media/empty-news.aa24c74c.png";